import React from "react";
import DocumentHead from "../components/common/DocumentHead";
import Hero from "../components/home/Hero";
import Services from "../components/home/Services";
import FeaturedProject from "../components/home/FeaturedProject";
import SelectedWorks from "../components/home/SelectedWorks";
import Contact from "../components/home/Contact";

/**
 * Home page.
 *
 * The order is a deliberate argument: show the work (hero), say what the
 * studio does (services), prove it with the current flagship (feature), prove
 * it again with the archive (works), then ask for the enquiry (contact).
 *
 * @returns {JSX.Element}
 */
function Home() {
  return (
    <>
      <DocumentHead
        title="ITArchitecture — Studio za arhitekturu, Srebrenik"
        description="Projektovanje, nadzor, izvođenje i konsalting. Stambeni, poslovni i turistički objekti širom Bosne i Hercegovine, sa virtualnim šetnjama kroz projekte."
      />
      <Hero />
      <Services />
      <FeaturedProject />
      <SelectedWorks />
      <Contact />
    </>
  );
}

export default Home;
